import { render, staticRenderFns } from "./Screen.vue?vue&type=template&id=9bf41b9a&scoped=true"
import script from "./Screen.vue?vue&type=script&lang=js"
export * from "./Screen.vue?vue&type=script&lang=js"
import style0 from "./Screen.vue?vue&type=style&index=0&id=9bf41b9a&prod&scoped=true&lang=less"
import style1 from "./Screen.vue?vue&type=style&index=1&id=9bf41b9a&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bf41b9a",
  null
  
)

export default component.exports